import { useEffect } from 'react'
import { trackInternalEvent } from '@rio/tracking'
import {
  DUAL_MODAL_FROM_DOWNLOAD_RESUME,
  useAutoApplyResumeDistributionModal,
} from './useAutoApplyResumeDistributionModal'
import { NonSupportedUserAutoApplyResumeDistributionModal } from './NonSupportedUserAutoApplyResumeDistributionModal'
import { SupportedUserAutoApplyResumeDistributionModal } from './SupportedUserAutoApplyResumeDistributionModal'

export const AutoApplyResumeDistributionModal = () => {
  const { isOpen, closeModal, planName, isInSupportedRegion } =
    useAutoApplyResumeDistributionModal()

  useEffect(() => {
    if (isOpen) {
      let option = {}
      if (localStorage.getItem(DUAL_MODAL_FROM_DOWNLOAD_RESUME) === 'true') {
        option = { label: 'resume_download' }
      }
      localStorage.removeItem(DUAL_MODAL_FROM_DOWNLOAD_RESUME)
      trackInternalEvent('show_auto_apply_upsell_modal', option)
    }
  }, [isOpen])

  if (!isOpen) return null

  if (isInSupportedRegion) {
    return <SupportedUserAutoApplyResumeDistributionModal closeModal={closeModal} />
  }

  return (
    <NonSupportedUserAutoApplyResumeDistributionModal planName={planName} closeModal={closeModal} />
  )
}
